module.exports = __webpack_public_path__ + "static/media/Lens-Radiant Chic_diameter.f3ee4154.png";